import { LanguageEntries } from './LanguageEntries';
import * as React from 'react';
import { germanLanguage } from './German';
import { englishLanguage } from './English';
import { LanguageContext } from './LanguageContext';

export type Languages = 'de' | 'en';

let currentLanguage: Languages | null = null;

// export const LanguageProvider = React.createContext(germanLanguage);

export const setCurrentLanguage = (language: Languages) => {
  currentLanguage = language;
};

export type AvailableLanguages = { [key: string]: LanguageContext };
export const availableLanguages: AvailableLanguages = {
  ['de']: germanLanguage,
  ['en']: englishLanguage,
};

export type Translator = (entry: keyof LanguageEntries) => string|undefined;

// export const getCurrentLanguage = (): string => {
//   if (currentLanguage == null) {
//     const lng = document.documentElement.getAttribute('lang');
//     switch (lng) {
//       case 'en-GB':
//         currentLanguage = 'en';
//         break;
//       default:
//         currentLanguage = 'de';
//         break;
//     }
//   }
//   return currentLanguage as string;
// };



// WEBPACK FOOTER //
// ./src/shared/language/Language.tsx